<template>
  <section class="specialization-section">
    <!-- 기하학적 배경 (좌우 대칭) -->
    <div class="geometric-bg">
      <svg class="geo-svg" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice">
        <!-- 좌측 큰 원 -->
        <circle cx="120" cy="200" r="180" class="geo-shape geo-circle-1" />
        <!-- 우측 큰 원 (대칭) -->
        <circle cx="1800" cy="200" r="180" class="geo-shape geo-circle-2" />

        <!-- 좌측 하단 원 -->
        <circle cx="200" cy="880" r="120" class="geo-shape geo-circle-3" />
        <!-- 우측 하단 원 (대칭) -->
        <circle cx="1720" cy="880" r="120" class="geo-shape geo-circle-4" />

        <!-- 중앙 상단 작은 원 -->
        <circle cx="960" cy="60" r="40" class="geo-shape geo-circle-5" />

        <!-- 좌측 사각형 -->
        <rect x="80" y="480" width="140" height="140" class="geo-shape geo-rect-1" />
        <!-- 우측 사각형 (대칭) -->
        <rect x="1700" y="480" width="140" height="140" class="geo-shape geo-rect-2" />

        <!-- 좌측 마름모 -->
        <rect x="300" y="300" width="80" height="80" transform="rotate(45, 340, 340)" class="geo-shape geo-diamond-1" />
        <!-- 우측 마름모 (대칭) -->
        <rect x="1540" y="300" width="80" height="80" transform="rotate(45, 1580, 340)" class="geo-shape geo-diamond-2" />

        <!-- 좌측 대각선 -->
        <line x1="0" y1="650" x2="350" y2="350" class="geo-shape geo-line-1" />
        <!-- 우측 대각선 (대칭) -->
        <line x1="1570" y1="350" x2="1920" y2="650" class="geo-shape geo-line-2" />

        <!-- 좌측 수직선 -->
        <line x1="420" y1="150" x2="420" y2="500" class="geo-shape geo-line-4" />
        <!-- 우측 수직선 (대칭) -->
        <line x1="1500" y1="150" x2="1500" y2="500" class="geo-shape geo-line-5" />

        <!-- 하단 수평선 -->
        <line x1="700" y1="980" x2="1220" y2="980" class="geo-shape geo-line-3" />
      </svg>
    </div>

    <!-- 워터마크 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="watermark-logo" />

    <!-- 상단 로고 -->
    <div class="section-header">
      <img src="@/assets/logo/logo_symbol.png" alt="" class="symbol-logo" />
      <h2 class="section-title">Location Premium</h2>
    </div>

    <!-- 카드 그리드 -->
    <div class="cards-container">
      <div class="card-wrapper" v-for="(item, index) in items" :key="index">
        <div
          class="spec-card"
          :class="{ active: activeCard === index }"
          @mouseenter="activeCard = index"
          @mouseleave="activeCard = null"
        >
          <!-- 배경 이미지 -->
          <div class="card-image" :class="{ active: activeCard === index }">
            <img :src="item.image" :alt="item.title" />
          </div>

          <!-- 콘텐츠 -->
          <div class="card-content">
            <h3 class="card-title">{{ item.title }}</h3>
            <transition name="fade-up">
              <p class="card-desc" v-if="activeCard === index">{{ item.desc }}</p>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SpecializationSection',
  data() {
    return {
      activeCard: null,
      items: [
        {
          title: '고속철도(KTX) 오송역',
          desc: '서울역(50분대 소요), 부산역(1시간 40분대 소요)으로\n바로 이동할 수 있어\n전국 2시간대 생활권',
          image: 'https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=600&q=80'
        },
        {
          title: '복선전철 북청주역(예정)',
          desc: '천안~청주공항 복선전철\n북청주역 개통 예정(2029년)으로\n청주 테크노폴리스로의 접근이 용이',
          image: 'https://images.unsplash.com/photo-1515165562839-978bbcf18277?w=600&q=80'
        },
        {
          title: '다양한 쾌속루트',
          desc: '청주2순환로, 중부고속도로 서청주IC가\n인접해 있어 빠르게 이용할 수 있는\n다양한 광역교통망',
          image: 'https://images.unsplash.com/photo-1545459720-aac8509eb02c?w=600&q=80'
        },
        {
          title: '청주국제공항 항공루트',
          desc: '제주행 국내선을 비롯하여\n일부 국제선까지 운행하고 있어\n가까이에서 편리하게 항공편 이용 가능',
          image: 'https://images.unsplash.com/photo-1529074963764-98f45c47344b?w=600&q=80'
        }
      ]
    }
  }
}
</script>

<style scoped>
.specialization-section {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 60px;
  position: relative;
  overflow: hidden;
}

/* 기하학적 배경 */
.geometric-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.geo-svg {
  width: 100%;
  height: 100%;
}

.geo-shape {
  fill: none;
  stroke: rgba(163, 32, 53, 0.15);
  stroke-width: 1.5;
}

/* 원들 */
.geo-circle-1 {
  stroke-dasharray: 1382;
  stroke-dashoffset: 1382;
  animation: drawShape 6s ease-out forwards;
}

.geo-circle-2 {
  stroke-dasharray: 942;
  stroke-dashoffset: 942;
  animation: drawShape 5s ease-out 0.3s forwards;
}

.geo-circle-3 {
  stroke-dasharray: 628;
  stroke-dashoffset: 628;
  animation: drawShape 4s ease-out 0.6s forwards;
}

.geo-circle-4 {
  stroke-dasharray: 754;
  stroke-dashoffset: 754;
  animation: drawShape 4s ease-out 0.9s forwards;
}

.geo-circle-5 {
  stroke-dasharray: 314;
  stroke-dashoffset: 314;
  animation: drawShape 3s ease-out 1.2s forwards;
}

/* 사각형들 */
.geo-rect-1 {
  stroke-dasharray: 720;
  stroke-dashoffset: 720;
  animation: drawShape 5s ease-out 0.4s forwards;
}

.geo-rect-2 {
  stroke-dasharray: 480;
  stroke-dashoffset: 480;
  animation: drawShape 4s ease-out 0.7s forwards;
}

/* 마름모들 */
.geo-diamond-1 {
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  animation: drawShape 4s ease-out 1s forwards;
}

.geo-diamond-2 {
  stroke-dasharray: 320;
  stroke-dashoffset: 320;
  animation: drawShape 3s ease-out 1.3s forwards;
}

/* 선들 */
.geo-line-1 {
  stroke-dasharray: 566;
  stroke-dashoffset: 566;
  animation: drawShape 3s ease-out 0.2s forwards;
}

.geo-line-2 {
  stroke-dasharray: 500;
  stroke-dashoffset: 500;
  animation: drawShape 3s ease-out 0.5s forwards;
}

.geo-line-3 {
  stroke-dasharray: 700;
  stroke-dashoffset: 700;
  animation: drawShape 4s ease-out 0.8s forwards;
}

.geo-line-4 {
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  animation: drawShape 3s ease-out 1.1s forwards;
}

.geo-line-5 {
  stroke-dasharray: 350;
  stroke-dashoffset: 350;
  animation: drawShape 3s ease-out 1.4s forwards;
}

/* 삼각형 */
.geo-triangle {
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: drawShape 3s ease-out 1.6s forwards;
}

@keyframes drawShape {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes floatShape {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

@keyframes rotateShape {
  from {
    transform: rotate(45deg);
  }
  to {
    transform: rotate(405deg);
  }
}

/* 워터마크 */
.watermark-logo {
  position: absolute;
  bottom: -15%;
  right: -10%;
  width: 900px;
  height: auto;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
}

/* 헤더 */
.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
  position: relative;
  z-index: 1;
}

.symbol-logo {
  width: 100px;
  height: auto;
  margin-bottom: 28px;
}

.section-title {
  font-family: var(--font-luxury);
  font-size: 64px;
  font-weight: 500;
  color: #2c3e50;
  letter-spacing: 8px;
  text-transform: uppercase;
}

/* 카드 컨테이너 */
.cards-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 1600px;
  height: 680px;
  position: relative;
  z-index: 1;
}

/* 카드 래퍼 - 고정 크기 유지 */
.card-wrapper {
  flex: 1;
  max-width: 360px;
  height: 680px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

/* 카드 */
.spec-card {
  width: 100%;
  height: 620px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: height 0.5s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.5s ease;
}

.spec-card.active {
  height: 680px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

/* 카드 이미지 */
.card-image {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 680px;
  transform: translateY(-50%);
  filter: grayscale(100%);
  transition: filter 0.5s ease;
}

.card-image.active {
  filter: grayscale(0%);
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 255, 255, 0.5) 25%,
    rgba(255, 255, 255, 0) 45%
  );
  transition: background 0.5s ease;
}

.spec-card.active .card-image::after {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(255, 255, 255, 0.7) 30%,
    rgba(255, 255, 255, 0) 50%
  );
}

/* 카드 콘텐츠 */
.card-content {
  position: relative;
  z-index: 1;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-family: var(--font-paperlogy);
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
  text-align: center;
}

.card-desc {
  font-family: var(--font-pretendard);
  font-size: 15px;
  line-height: 1.9;
  color: #555;
  text-align: center;
  white-space: pre-line;
}

/* 트랜지션 */
.fade-up-enter-active {
  transition: all 0.4s ease;
}

.fade-up-leave-active {
  transition: all 0.2s ease;
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
